"use strict";
function _typeof(t) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) {
          return typeof t;
        }
      : function (t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t;
        })(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o =
      Object.defineProperty ||
      function (t, e, r) {
        t[e] = r.value;
      },
    i =
      (b = "function" == typeof Symbol ? Symbol : {}).iterator || "@@iterator",
    a = b.asyncIterator || "@@asyncIterator",
    s = b.toStringTag || "@@toStringTag";
  function c(t, e, r) {
    return (
      Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0,
      }),
      t[e]
    );
  }
  try {
    c({}, "");
  } catch (t) {
    c = function (t, e, r) {
      return (t[e] = r);
    };
  }
  function u(e, r, n, i) {
    var a, s, c, u;
    (r = r && r.prototype instanceof v ? r : v),
      (r = Object.create(r.prototype)),
      (i = new j(i || []));
    return (
      o(r, "_invoke", {
        value:
          ((a = e),
          (s = n),
          (c = i),
          (u = d),
          function (e, r) {
            if (u === p) throw new Error("Generator is already running");
            if (u === y) {
              if ("throw" === e) throw r;
              return { value: t, done: !0 };
            }
            for (c.method = e, c.arg = r; ; ) {
              var n = c.delegate;
              if (
                n &&
                ((n = (function e(r, n) {
                  var o = n.method,
                    i = r.iterator[o];
                  return i === t
                    ? ((n.delegate = null),
                      ("throw" === o &&
                        r.iterator.return &&
                        ((n.method = "return"),
                        (n.arg = t),
                        e(r, n),
                        "throw" === n.method)) ||
                        ("return" !== o &&
                          ((n.method = "throw"),
                          (n.arg = new TypeError(
                            "The iterator does not provide a '" + o + "' method"
                          )))),
                      h)
                    : "throw" === (o = l(i, r.iterator, n.arg)).type
                    ? ((n.method = "throw"),
                      (n.arg = o.arg),
                      (n.delegate = null),
                      h)
                    : (i = o.arg)
                    ? i.done
                      ? ((n[r.resultName] = i.value),
                        (n.next = r.nextLoc),
                        "return" !== n.method &&
                          ((n.method = "next"), (n.arg = t)),
                        (n.delegate = null),
                        h)
                      : i
                    : ((n.method = "throw"),
                      (n.arg = new TypeError(
                        "iterator result is not an object"
                      )),
                      (n.delegate = null),
                      h);
                })(n, c)),
                n)
              ) {
                if (n === h) continue;
                return n;
              }
              if ("next" === c.method) c.sent = c._sent = c.arg;
              else if ("throw" === c.method) {
                if (u === d) throw ((u = y), c.arg);
                c.dispatchException(c.arg);
              } else "return" === c.method && c.abrupt("return", c.arg);
              if (((u = p), "normal" === (n = l(a, s, c)).type)) {
                if (((u = c.done ? y : f), n.arg === h)) continue;
                return { value: n.arg, done: c.done };
              }
              "throw" === n.type &&
                ((u = y), (c.method = "throw"), (c.arg = n.arg));
            }
          }),
      }),
      r
    );
  }
  function l(t, e, r) {
    try {
      return { type: "normal", arg: t.call(e, r) };
    } catch (t) {
      return { type: "throw", arg: t };
    }
  }
  e.wrap = u;
  var d = "suspendedStart",
    f = "suspendedYield",
    p = "executing",
    y = "completed",
    h = {};
  function v() {}
  function _() {}
  function m() {}
  var b,
    g,
    w =
      ((g =
        (g =
          (c((b = {}), i, function () {
            return this;
          }),
          Object.getPrototypeOf)) && g(g(x([])))) &&
        g !== r &&
        n.call(g, i) &&
        (b = g),
      (m.prototype = v.prototype = Object.create(b)));
  function L(t) {
    ["next", "throw", "return"].forEach(function (e) {
      c(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function S(t, e) {
    var r;
    o(this, "_invoke", {
      value: function (o, i) {
        function a() {
          return new e(function (r, a) {
            !(function r(o, i, a, s) {
              var c;
              if ("throw" !== (o = l(t[o], t, i)).type)
                return (i = (c = o.arg).value) &&
                  "object" == _typeof(i) &&
                  n.call(i, "__await")
                  ? e.resolve(i.__await).then(
                      function (t) {
                        r("next", t, a, s);
                      },
                      function (t) {
                        r("throw", t, a, s);
                      }
                    )
                  : e.resolve(i).then(
                      function (t) {
                        (c.value = t), a(c);
                      },
                      function (t) {
                        return r("throw", t, a, s);
                      }
                    );
              s(o.arg);
            })(o, i, r, a);
          });
        }
        return (r = r ? r.then(a, a) : a());
      },
    });
  }
  function E(t) {
    var e = { tryLoc: t[0] };
    1 in t && (e.catchLoc = t[1]),
      2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
      this.tryEntries.push(e);
  }
  function P(t) {
    var e = t.completion || {};
    (e.type = "normal"), delete e.arg, (t.completion = e);
  }
  function j(t) {
    (this.tryEntries = [{ tryLoc: "root" }]),
      t.forEach(E, this),
      this.reset(!0);
  }
  function x(e) {
    if (e || "" === e) {
      var r,
        o = e[i];
      if (o) return o.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length))
        return (
          (r = -1),
          ((o = function o() {
            for (; ++r < e.length; )
              if (n.call(e, r)) return (o.value = e[r]), (o.done = !1), o;
            return (o.value = t), (o.done = !0), o;
          }).next = o)
        );
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return (
    o(w, "constructor", { value: (_.prototype = m), configurable: !0 }),
    o(m, "constructor", { value: _, configurable: !0 }),
    (_.displayName = c(m, s, "GeneratorFunction")),
    (e.isGeneratorFunction = function (t) {
      return (
        !!(t = "function" == typeof t && t.constructor) &&
        (t === _ || "GeneratorFunction" === (t.displayName || t.name))
      );
    }),
    (e.mark = function (t) {
      return (
        Object.setPrototypeOf
          ? Object.setPrototypeOf(t, m)
          : ((t.__proto__ = m), c(t, s, "GeneratorFunction")),
        (t.prototype = Object.create(w)),
        t
      );
    }),
    (e.awrap = function (t) {
      return { __await: t };
    }),
    L(S.prototype),
    c(S.prototype, a, function () {
      return this;
    }),
    (e.AsyncIterator = S),
    (e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new S(u(t, r, n, o), i);
      return e.isGeneratorFunction(r)
        ? a
        : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
    }),
    L(w),
    c(w, s, "Generator"),
    c(w, i, function () {
      return this;
    }),
    c(w, "toString", function () {
      return "[object Generator]";
    }),
    (e.keys = function (t) {
      var e,
        r = Object(t),
        n = [];
      for (e in r) n.push(e);
      return (
        n.reverse(),
        function t() {
          for (; n.length; ) {
            var e = n.pop();
            if (e in r) return (t.value = e), (t.done = !1), t;
          }
          return (t.done = !0), t;
        }
      );
    }),
    (e.values = x),
    (j.prototype = {
      constructor: j,
      reset: function (e) {
        if (
          ((this.prev = 0),
          (this.next = 0),
          (this.sent = this._sent = t),
          (this.done = !1),
          (this.delegate = null),
          (this.method = "next"),
          (this.arg = t),
          this.tryEntries.forEach(P),
          !e)
        )
          for (var r in this)
            "t" === r.charAt(0) &&
              n.call(this, r) &&
              !isNaN(+r.slice(1)) &&
              (this[r] = t);
      },
      stop: function () {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function (e) {
        if (this.done) throw e;
        var r = this;
        function o(n, o) {
          return (
            (s.type = "throw"),
            (s.arg = e),
            (r.next = n),
            o && ((r.method = "next"), (r.arg = t)),
            !!o
          );
        }
        for (var i = this.tryEntries.length - 1; 0 <= i; --i) {
          var a = this.tryEntries[i],
            s = a.completion;
          if ("root" === a.tryLoc) return o("end");
          if (a.tryLoc <= this.prev) {
            var c = n.call(a, "catchLoc"),
              u = n.call(a, "finallyLoc");
            if (c && u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function (t, e) {
        for (var r = this.tryEntries.length - 1; 0 <= r; --r) {
          var o = this.tryEntries[r];
          if (
            o.tryLoc <= this.prev &&
            n.call(o, "finallyLoc") &&
            this.prev < o.finallyLoc
          ) {
            var i = o;
            break;
          }
        }
        var a = (i =
          i &&
          ("break" === t || "continue" === t) &&
          i.tryLoc <= e &&
          e <= i.finallyLoc
            ? null
            : i)
          ? i.completion
          : {};
        return (
          (a.type = t),
          (a.arg = e),
          i
            ? ((this.method = "next"), (this.next = i.finallyLoc), h)
            : this.complete(a)
        );
      },
      complete: function (t, e) {
        if ("throw" === t.type) throw t.arg;
        return (
          "break" === t.type || "continue" === t.type
            ? (this.next = t.arg)
            : "return" === t.type
            ? ((this.rval = this.arg = t.arg),
              (this.method = "return"),
              (this.next = "end"))
            : "normal" === t.type && e && (this.next = e),
          h
        );
      },
      finish: function (t) {
        for (var e = this.tryEntries.length - 1; 0 <= e; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t)
            return this.complete(r.completion, r.afterLoc), P(r), h;
        }
      },
      catch: function (t) {
        for (var e = this.tryEntries.length - 1; 0 <= e; --e) {
          var r,
            n,
            o = this.tryEntries[e];
          if (o.tryLoc === t)
            return (
              "throw" === (r = o.completion).type && ((n = r.arg), P(o)), n
            );
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (e, r, n) {
        return (
          (this.delegate = { iterator: x(e), resultName: r, nextLoc: n }),
          "next" === this.method && (this.arg = t),
          h
        );
      },
    }),
    e
  );
}
function asyncGeneratorStep(t, e, r, n, o, i, a) {
  try {
    var s = t[i](a),
      c = s.value;
  } catch (t) {
    return void r(t);
  }
  s.done ? e(c) : Promise.resolve(c).then(n, o);
}
function _asyncToGenerator(t) {
  return function () {
    var e = this,
      r = arguments;
    return new Promise(function (n, o) {
      var i = t.apply(e, r);
      function a(t) {
        asyncGeneratorStep(i, n, o, a, s, "next", t);
      }
      function s(t) {
        asyncGeneratorStep(i, n, o, a, s, "throw", t);
      }
      a(void 0);
    });
  };
}
function _classCallCheck(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      "value" in n && (n.writable = !0),
      Object.defineProperty(t, _toPropertyKey(n.key), n);
  }
}
function _createClass(t, e, r) {
  return (
    e && _defineProperties(t.prototype, e),
    r && _defineProperties(t, r),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function");
  (t.prototype = Object.create(e && e.prototype, {
    constructor: { value: t, writable: !0, configurable: !0 },
  })),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    e && _setPrototypeOf(t, e);
}
function _createSuper(t) {
  var e = _isNativeReflectConstruct();
  return function () {
    var r,
      n = _getPrototypeOf(t);
    return _possibleConstructorReturn(
      this,
      e
        ? ((r = _getPrototypeOf(this).constructor),
          Reflect.construct(n, arguments, r))
        : n.apply(this, arguments)
    );
  };
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" === _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e)
    throw new TypeError(
      "Derived constructors may only return object or undefined"
    );
  return _assertThisInitialized(t);
}
function _assertThisInitialized(t) {
  if (void 0 === t)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return t;
}
function _wrapNativeSuper(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (_wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t)
      throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }
    function r() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return (
      (r.prototype = Object.create(t.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
      _setPrototypeOf(r, t)
    );
  })(t);
}
function _construct(t, e, r) {
  return (_construct = _isNativeReflectConstruct()
    ? Reflect.construct.bind()
    : function (t, e, r) {
        var n = [null];
        return (
          n.push.apply(n, e),
          (e = new (Function.bind.apply(t, n))()),
          r && _setPrototypeOf(e, r.prototype),
          e
        );
      }).apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return (
      Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      ),
      !0
    );
  } catch (t) {
    return !1;
  }
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (e) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return (_setPrototypeOf = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function (t, e) {
        return (t.__proto__ = e), t;
      })(t, e);
}
function _getPrototypeOf(t) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
}
function _defineProperty(t, e, r) {
  return (
    (e = _toPropertyKey(e)) in t
      ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = r),
    t
  );
}
function _toPropertyKey(t) {
  return "symbol" === _typeof((t = _toPrimitive(t, "string"))) ? t : String(t);
}
function _toPrimitive(t, e) {
  if ("object" !== _typeof(t) || null === t) return t;
  var r = t[Symbol.toPrimitive];
  if (void 0 === r) return ("string" === e ? String : Number)(t);
  if ("object" !== _typeof((r = r.call(t, e || "default")))) return r;
  throw new TypeError("@@toPrimitive must return a primitive value.");
}
!(function t(e, r, n) {
  function o(a, s) {
    if (!r[a]) {
      if (!e[a]) {
        var c = "function" == typeof require && require;
        if (!s && c) return c(a, !0);
        if (i) return i(a, !0);
        throw (
          (((s = new Error("Cannot find module '" + a + "'")).code =
            "MODULE_NOT_FOUND"),
          s)
        );
      }
      (c = r[a] = { exports: {} }),
        e[a][0].call(
          c.exports,
          function (t) {
            return o(e[a][1][t] || t);
          },
          c,
          c.exports,
          t,
          e,
          r,
          n
        );
    }
    return r[a].exports;
  }
  for (
    var i = "function" == typeof require && require, a = 0;
    a < n.length;
    a++
  )
    o(n[a]);
  return o;
})(
  {
    1: [
      function (t, e, r) {
        customElements.get("s-side-cart") ||
          customElements.define(
            "s-side-cart",
            (function () {
              _inherits(e, _wrapNativeSuper(HTMLElement));
              var t = _createSuper(e);
              function e() {
                var r;
                return (
                  _classCallCheck(this, e),
                  _defineProperty(
                    _assertThisInitialized((r = t.call(this))),
                    "updateVariables",
                    function () {
                      var t;
                      (r.sectionId = r.dataset.sectionId),
                        (r.sideCartWrapper = _assertThisInitialized(r)),
                        (r.overlay = r.querySelector(".js-side-cart__overlay")),
                        (r.content = r.querySelector(".js-side-cart__wrapper")),
                        (r.renderContainer = r.querySelector(
                          ".js-side-cart__content"
                        )),
                        (r.closeButton = r.querySelector(
                          ".js-side-cart__close-button"
                        )),
                        (r.deleteItemButtons = r.querySelectorAll(
                          ".js-side-cart__remove-button"
                        )),
                        (r.quantityInputs = r.querySelectorAll(
                          ".js-side-cart__qty-input"
                        )),
                        (r.quantityIncreaseButtons = r.querySelectorAll(
                          ".js-side-cart__qty-button--plus"
                        )),
                        (r.quantityDecreaseButtons = r.querySelectorAll(
                          ".js-side-cart__qty-button--minus"
                        )),
                        (r.openDeliveryDrawerButton = r.querySelector(
                          ".js-side-cart__open-delivery-drawer"
                        )),
                        (r.loader = r.querySelector(".js-side-cart__loader")),
                        r.overlay.addEventListener("click", r.toggleSideCart),
                        r.closeButton.addEventListener(
                          "click",
                          r.toggleSideCart
                        ),
                        r.deleteItemButtons.forEach(function (t) {
                          t.addEventListener("click", r.deleteItem);
                        }),
                        r.quantityInputs.forEach(function (t) {
                          t.addEventListener("change", r.updateQuantity);
                        }),
                        r.quantityIncreaseButtons.forEach(function (t) {
                          t.addEventListener("click", r.increaseQuantity);
                        }),
                        r.quantityDecreaseButtons.forEach(function (t) {
                          t.addEventListener("click", r.decreaseQuantity);
                        }),
                        null != (t = r.openDeliveryDrawerButton) &&
                          t.addEventListener("click", r.openDeliveryDrawer),
                        (r.closeSideCartUnsubscriber = window.PubSub.subscribe(
                          "s-delivery-info-drawer:close-side-cart",
                          r.toggleSideCart
                        )),
                        (window.toggleSideCart = r.toggleSideCart),
                        (window.updateSideCart = r.updateCartContent),
                        (r.cartUpdateUnsubscriber = window.PubSub.subscribe(
                          "cart-updated",
                          function (t) {
                            r.updateCartContent(),
                              r.classList.contains("s-side-cart--cart-page") ||
                                r.openSideCart();
                          }
                        ));
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "deleteItem",
                    (function () {
                      var t = _asyncToGenerator(
                        _regeneratorRuntime().mark(function t(e) {
                          var n;
                          return _regeneratorRuntime().wrap(function (t) {
                            for (;;)
                              switch ((t.prev = t.next)) {
                                case 0:
                                  return (
                                    e.preventDefault(),
                                    (n = {
                                      id: (n =
                                        e.target.dataset.itemId ||
                                        e.target.parentNode.dataset.itemId),
                                      quantity: 0,
                                    }),
                                    (t.next = 5),
                                    fetch(
                                      window.Shopify.routes.root +
                                        "cart/change.js",
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(n),
                                      }
                                    )
                                      .then(function (t) {
                                        return t.json();
                                      })
                                      .then(function (t) {
                                        r.renderContainer.classList.add(
                                          "wait-response"
                                        ),
                                          window.PubSub.publish(
                                            "cart-updated",
                                            t
                                          );
                                      })
                                      .catch(function (t) {
                                        console.error("Error:", t);
                                      })
                                  );
                                case 5:
                                case "end":
                                  return t.stop();
                              }
                          }, t);
                        })
                      );
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    })()
                  ),
          _defineProperty(
  _assertThisInitialized(r),
  "increaseQuantity",
  function (t) {
    var plusBtn = t.target;
    var minusBtn = plusBtn.parentNode.querySelector(
      ".js-side-cart__qty-button--minus"
    );
    var input = plusBtn.parentNode.querySelector(
      ".js-side-cart__qty-input"
    );

    if (!input) return !1;

    var current = parseInt(input.value);
    var max = parseInt(input.max);
    var min = parseInt(input.min);

    if (current < max) {
      input.value = current + 1;
      input.dispatchEvent(new Event("change"));
    }
    parseInt(input.value) >= max
      ? plusBtn.classList.add("s-side-cart__qty-button--disabled")
      : plusBtn.classList.remove("s-side-cart__qty-button--disabled");
    parseInt(input.value) <= min
      ? minusBtn.classList.add("s-side-cart__qty-button--disabled")
      : minusBtn.classList.remove("s-side-cart__qty-button--disabled");
  }
),

                  _defineProperty(
                    _assertThisInitialized(r),
                    "decreaseQuantity",
                    function (t) {
                      var e = (t = t.target).parentNode.querySelector(
                          ".js-side-cart__qty-button--plus"
                        ),
                        r = t.parentNode.querySelector(
                          ".js-side-cart__qty-input"
                        );
                      if (!r) return !1;
                      r.value > r.min &&
                        ((r.value = parseInt(r.value) - 1),
                        r.dispatchEvent(new Event("change"))),
                        r.value > r.min
                          ? t.classList.remove(
                              "s-side-cart__qty-button--disabled"
                            )
                          : t.classList.add(
                              "s-side-cart__qty-button--disabled"
                            ),
                        r.value < r.max
                          ? e.classList.remove(
                              "s-side-cart__qty-button--disabled"
                            )
                          : e.classList.add(
                              "s-side-cart__qty-button--disabled"
                            );
                    }
                  ),
     _defineProperty(
  _assertThisInitialized(r),
  "updateQuantity",
  (function () {
    var t = _asyncToGenerator(
      _regeneratorRuntime().mark(function t(e) {
        var input, itemId, quantity;
        return _regeneratorRuntime().wrap(function (t) {
          for (;;)
            switch ((t.prev = t.next)) {
              case 0:
                return (
                  e.preventDefault(),

                  // Get the input element
                  (input = e.target),

                  // Enforce min/max
                  parseInt(input.value) > parseInt(input.max) &&
                    (input.value = input.max),
                  parseInt(input.value) < parseInt(input.min) &&
                    (input.value = input.min),

                  // Prepare payload
                  (itemId = input.dataset.itemId),
                  (quantity = parseInt(input.value)),

                  !itemId
                    ? t.abrupt("return")
                    : (t.next = 8,
                      fetch(
                        window.Shopify.routes.root + "cart/change.js",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify({
                            id: itemId,
                            quantity: quantity,
                          }),
                        }
                      )
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (data) {
                            console.log("Quantity update response:", data);
 
                          window.PubSub.publish("cart-updated", data);
                        })
                        .catch(function (err) {
                          console.error("Error updating quantity:", err);
                        }))
                );
              case 8:
              case "end":
                return t.stop();
            }
        }, t);
      })
    );
    return function (e) {
      return t.apply(this, arguments);
    };
  })()
),

                  _defineProperty(
                    _assertThisInitialized(r),
                    "openSideCart",
                    function () {
                      r.sideCartWrapper.classList.contains(
                        "s-side-cart--open"
                      ) ||
                        (r.sideCartWrapper.classList.add("s-side-cart--open"),
                        document.body.classList.add("side-cart-active"),
                        r.overlay.classList.add("is-open"),
                        r.content.classList.add("is-open"),
                        r.lockScroll());
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "toggleSideCart",
                    function () {
                      r.sideCartWrapper.classList.contains("s-side-cart--open")
                        ? (r.sideCartWrapper.classList.remove(
                            "s-side-cart--open"
                          ),
                          document.body.classList.remove("side-cart-active"),
                          r.overlay.classList.remove("is-open"),
                          r.content.classList.remove("is-open"),
                          r.unlockScroll(),
                          window.PubSub.publish(
                            "s-side-cart:close-delivery-drawer",
                            ""
                          ))
                        : (r.sideCartWrapper.classList.add("s-side-cart--open"),
                          document.body.classList.add("side-cart-active"),
                          r.overlay.classList.add("is-open"),
                          r.content.classList.add("is-open"),
                          r.lockScroll());
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "unlockScroll",
                    function () {
                      var t =
                          -1 *
                          parseInt(
                            document.body.style.left.replace("px", "") || "0",
                            10
                          ),
                        e =
                          -1 *
                          parseInt(
                            document.body.style.top.replace("px", "") || "0",
                            10
                          );
                      (document.body.style.position = ""),
                        (document.body.style.top = ""),
                        (document.body.style.left = ""),
                        (document.body.style.right = ""),
                        window.scrollTo(t, e),
                        document.body.classList.remove("lock-scroll");
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "lockScroll",
                    function () {
                      (document.body.style.top = "-".concat(
                        window.scrollY,
                        "px"
                      )),
                        (document.body.style.left = "-".concat(
                          window.scrollX,
                          "px"
                        )),
                        (document.body.style.position = "fixed"),
                        (document.body.style.right = "0"),
                        document.body.classList.add("lock-scroll");
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "updateCartContent",
                    _asyncToGenerator(
                      _regeneratorRuntime().mark(function t() {
                        var e;
                        return _regeneratorRuntime().wrap(function (t) {
                          for (;;)
                            switch ((t.prev = t.next)) {
                              case 0:
                                return (
                                  (e =
                                    window.Shopify.routes.root +
                                    "?section=".concat(r.sectionId)),
                                  r.loader.classList.add("js-loading"),
                                  r.renderContainer.classList.add(
                                    "wait-response"
                                  ),
                                  (t.next = 5),
                                  fetch(e, {
                                    method: "GET",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Accept: "application/json",
                                    },
                                  })
                                    .then(function (t) {
                                      return t.text();
                                    })
                                    .then(function (t) {
                                      var e = "#".concat(r.sectionId);
                                      t = new DOMParser().parseFromString(
                                        t,
                                        "text/html"
                                      );
                                      (document
                                        .querySelector(e)
                                        .querySelector(
                                          "style[data-shopify]"
                                        ).innerHTML = t
                                        .querySelector(e)
                                        .querySelector(
                                          "style[data-shopify]"
                                        ).innerHTML),
                                        (r.renderContainer.innerHTML =
                                          t.querySelector(
                                            ".js-side-cart__content"
                                          ).innerHTML),
                                        r.renderContainer.classList.remove(
                                          "wait-response"
                                        ),
                                        r.cartUpdateUnsubscriber(),
                                        r.updateVariables(),
                                        updateNoticeDisplay();
                                    })
                                    .finally(function () {
                                      r.loader.classList.remove("js-loading");
                                    })
                                );
                              case 5:
                              case "end":
                                return t.stop();
                            }
                        }, t);
                      })
                    )
                  ),
                  _defineProperty(
                    _assertThisInitialized(r),
                    "openDeliveryDrawer",
                    function () {
                      window.PubSub.publish(
                        "s-side-cart:open-delivery-drawer",
                        ""
                      );
                    }
                  ),
                  r
                );
              }
              return (
                _createClass(e, [
                  {
                    key: "connectedCallback",
                    value: function () {
                      this.updateVariables();
                    },
                  },
                  {
                    key: "disconnectedCallback",
                    value: function () {
                      var t,
                        e = this;
                      this.overlay.removeEventListener(
                        "click",
                        this.toggleSideCart
                      ),
                        this.closeButton.removeEventListener(
                          "click",
                          this.toggleSideCart
                        ),
                        this.deleteItemButtons.forEach(function (t) {
                          t.removeEventListener("click", e.deleteItem);
                        }),
                        this.quantityInputs.forEach(function (t) {
                          t.removeEventListener("change", e.updateQuantity);
                        }),
                        this.quantityIncreaseButtons.forEach(function (t) {
                          t.removeEventListener("click", e.increaseQuantity);
                        }),
                        this.quantityDecreaseButtons.forEach(function (t) {
                          t.removeEventListener("click", e.decreaseQuantity);
                        }),
                        null != (t = this.openDeliveryDrawerButton) &&
                          t.removeEventListener(
                            "click",
                            this.openDeliveryDrawer
                          ),
                        this.closeSideCartUnsubscriber(),
                        this.cartUpdateUnsubscriber();
                    },
                  },
                ]),
                e
              );
            })()
          );
      },
      {},
    ],
  },
  {},
  [1]
);
